import React from 'react';
import axios from 'axios';

import WithConfirm from '~/components/ConfirmModal';
import Button from '~/components/core/Atomic/Buttons/Button';
import { useSysconfig } from '~/components/SystemConfiguration/SystemConfigurationScreen';
import type { OrganizationModel } from '~/components/types/organization-types';
import { reportAxiosError } from '~/Utils';

export const DemoClaimsConfiguration: React.FC = () => {
  const { organization } = useSysconfig() as { organization: OrganizationModel };

  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const handleDeleteClaims = async (): Promise<void> => {
    try {
      setIsSubmitting(true);
      await axios.delete(`/sysconfig/api/v1/organizations/${organization.id}/demo_config/claims`);
    } catch (error) {
      await reportAxiosError(error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="min-h-[50vh] bg-white p-24">
      <WithConfirm
        title="Are you sure?"
        contentText={`This will remove all claims for organization ${organization.name}.`}
        primaryButtonName="Remove All Claims"
        shouldCloseOnPrimary={true}
      >
        <Button variant="contained" color="primary" onClick={handleDeleteClaims} disabled={isSubmitting}>
          Delete All Claims
        </Button>
      </WithConfirm>
    </div>
  );
};
